import { createContext, useContext, useState, type ReactNode } from "react";
import { defaultPipelines, DEFAULT_PIPELINE_ID } from "@/data/pipelines";
import type { Pipeline, PipelineStage } from "@/data/pipelines";

interface PipelinesContextValue {
  pipelines: Pipeline[];
  setPipelines: React.Dispatch<React.SetStateAction<Pipeline[]>>;
}

const PipelinesContext = createContext<PipelinesContextValue | null>(null);

export function PipelinesProvider({ children }: { children: ReactNode }) {
  const [pipelines, setPipelines] = useState<Pipeline[]>(defaultPipelines);

  return (
    <PipelinesContext.Provider value={{ pipelines, setPipelines }}>
      {children}
    </PipelinesContext.Provider>
  );
}

export function usePipelines() {
  const ctx = useContext(PipelinesContext);
  if (!ctx) throw new Error("usePipelines must be used within PipelinesProvider");
  return ctx;
}
